import React, { useContext, useEffect, useMemo } from 'react';
import {
  concat, map, sortBy, uniq,
} from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import menuContext from '../contexts/menu';
import DateFilterCmp from '../components/DateFilter';
import useQueryString from '../../hooks/useQueryString';
import { FILTER } from '../constants';

export default function DateFilter() {
  const history = useHistory();
  const { search } = useLocation();
  const { menuCache } = useContext(menuContext);
  const { filter, date: selectedDate } = useQueryString();
  const { dailyFreshPreOrderDates, onlineShopDates } = menuCache || {};

  useEffect(() => {
    const url = new URLSearchParams(search);

    if (filter === FILTER.GOODS_STATUS) {
      url.delete('date');
    }

    const newSearch = `?${url.toString()}`;

    if (search !== newSearch) history.replace({ search: newSearch });
  }, [filter, search, history]);

  const data = useMemo(() => concat(
    {
      isActivated: !selectedDate,
      label: '所有商品',
      value: '',
    },
    map(sortBy(uniq(concat(
      dailyFreshPreOrderDates || [],
      onlineShopDates || [],
    ))),
    (day) => {
      const label = `${moment(day).format('MM/DD')}到貨`;

      return {
        isActivated: selectedDate === day,
        label,
        value: day,
      };
    })
  ),
  [dailyFreshPreOrderDates, onlineShopDates, selectedDate]);

  const onItemClick = (item) => {
    const { value } = item || {};
    const url = new URLSearchParams(search);

    if (value) url.set('date', value);
    else url.delete('date');

    const newSearch = url.toString();

    history.push({ search: `?${newSearch}` });
  };

  return filter === FILTER.GOODS_STATUS ? null : (
    <DateFilterCmp data={data} onItemClick={onItemClick} />
  );
}
